import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// other imports
import { PermissionModule } from 'baseauth';
import { BaseUICommonModule } from 'baseuicommon';
import { SolarPipesModule } from 'solarpipes';


@NgModule({
  imports: [
   CommonModule
    ,PermissionModule.forRoot() 
   ,BaseUICommonModule
   ,SolarPipesModule
  ],
  declarations: [ 

  ],
  exports: [
   BaseUICommonModule
   ,PermissionModule
   ,SolarPipesModule
],
  
})
export class AppPipesModule {}
